import type { AccountAddress } from '#types/components/account/address'

/**
 * Returns Addresses with default address as first.
 * @param {Array<AccountAddress>} addresses - Array of all addresses.
 * @returns {Array<AccountAddress>} - Array of all addresses but with default address on top.
 * @category Utils
 */
export const sortAddressByDefault = (addresses: AccountAddress[]) => [...addresses].sort((a, _) => a.main ? -1 : 1)
